import type { ApiClient } from "@api/ApiClient";
import type { SessionMode } from "@constants/documentCategories";
import type { Session } from "./sessions.types";

type SessionsListResponse = { sessions?: Session[] };

export const listSessionsApi = async (apiClient: ApiClient, documentId: string): Promise<Session[]> => {
  const queryParams = new URLSearchParams({ documentId });
  const response = await apiClient.get(`/sessions?${queryParams.toString()}`);
  if (!response) throw new Error("No response from server");
  const { sessions = [] } = (await response.json()) as SessionsListResponse;
  return sessions;
};

type CreateSessionApiParams = {
  documentId: string;
  sessionMode: SessionMode;
  sessionName: string;
};

export const createSessionApi = async (
  apiClient: ApiClient,
  { documentId, sessionMode, sessionName }: CreateSessionApiParams
): Promise<Session> => {
  const config = { headers: { "Content-Type": "application/json" } };
  const body = JSON.stringify({ documentId, sessionMode, sessionName });
  const response = await apiClient.post(`/session`, body, config);
  if (!response) throw new Error("No response from server");
  return (await response.json()) as Session;
};

export const deleteSessionApi = async (apiClient: ApiClient, sessionId: string): Promise<void> => {
  await apiClient.delete(`/session?id=${encodeURIComponent(sessionId)}`);
};
